import { render, staticRenderFns } from "./ItemView.vue?vue&type=template&id=1aaf45ad&"
import script from "./ItemView.vue?vue&type=script&lang=js&"
export * from "./ItemView.vue?vue&type=script&lang=js&"
import style0 from "./ItemView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports